import { createFileRoute, notFound } from "@tanstack/react-router";

import { exploreSearchSchema } from "@blis/insights/explore/explore-url-state";
import { hasPermission } from "@blis/shared/permissions";

export const Route = createFileRoute("/_auth/_app/insights/explore")({
  validateSearch: (search) => exploreSearchSchema.parse(search),
  beforeLoad({ context: { user } }) {
    if (!hasPermission(user.role, "read:insights")) {
      throw notFound();
    }
  },
});
